import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../App";
import { ChevronRight, PawPrint, FileText, Syringe } from "lucide-react";

export default function VetPatients() {
  const [patients, setPatients] = useState([]);
  useEffect(() => { axios.get(`${API}/partner/vet/patients`).then(r => setPatients(r.data.patients)); }, []);

  return (
    <div className="space-y-6" data-testid="vet-patients-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold">My patients</h1>
        <p className="text-ink-soft text-sm">All pets you've seen or prescribed to — pick one to write a prescription or record a vaccination.</p>
      </div>
      {patients.length === 0 ? (
        <div className="bg-surface border border-line rounded-3xl p-10 text-center">
          <PawPrint className="w-10 h-10 mx-auto text-brand mb-2"/>
          <div className="font-heading text-lg font-bold">No patients yet</div>
          <p className="text-ink-soft text-sm mt-1">Once a pet parent books with you (or you write a prescription) they'll appear here.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {patients.map(p => (
            <Link key={p.pet_id} to={`/app/vet/prescribe/${p.pet_id}`} data-testid={`patient-${p.pet_id}`} className="bg-surface border border-line rounded-3xl p-4 flex items-center gap-3 shadow-soft hover:-translate-y-1 hover:shadow-hover transition-all">
              <img src={p.photo} alt={p.name} className="w-14 h-14 rounded-2xl object-cover"/>
              <div className="flex-1 min-w-0">
                <div className="font-heading font-bold">{p.name}</div>
                <div className="text-xs text-ink-soft">{p.breed} · {p.age_years}y</div>
                <div className="text-[11px] text-ink-soft mt-1">Owner: {p.owner?.name || "—"}</div>
              </div>
              <ChevronRight className="w-4 h-4 text-ink-soft"/>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
